import { useCallback, useContext, useMemo, useState } from 'react';
import { Menu } from './Menu';
import { SideCart } from './SideCart';
import { ViewPlacement } from './ViewPlacement';
import { Workspace } from './Workspace';
import { NonCartContext } from './noncart-context';
import { Placement, StreamingCreativesContext, TabKey } from './streaming-creatives-constants';

export const NonCart = () => {
  const { tab } = useContext(StreamingCreativesContext);

  const [viewPlacementId, setViewPlacementId] = useState<string>();
  const [filteredPlacements, setFilteredPlacementsRaw] = useState<string[]>([]);

  const setFilteredPlacements = useCallback((placements: Placement[]) => {
    setFilteredPlacementsRaw(placements.map(placement => placement.id));
  }, []);

  const contextValue = useMemo(
    () => ({ viewPlacementId, setViewPlacementId, filteredPlacements, setFilteredPlacements }),
    [viewPlacementId, filteredPlacements, setFilteredPlacements]
  );

  return (
    <NonCartContext.Provider value={contextValue}>
      <div className='non-cart'>{tab === TabKey.WORKSPACE ? <Workspace /> : <Menu />}</div>
      <SideCart />
      {Boolean(viewPlacementId) && <ViewPlacement />}
    </NonCartContext.Provider>
  );
};
